import * as yup from 'yup';

import { allgemeinKfzSchema } from '@/features/Sparten/shared/schema/kfz/allgemeinSchema/allgemeinSchema';

export const allgemeinSchema = allgemeinKfzSchema.concat(
  yup.object({
    wkz: yup.string().default(''),
  }),
);

export type AllgemeinSchema = yup.Asserts<typeof allgemeinSchema>;
